import useTokenStore from "@/store/token";
import {useNavigate} from "react-router";
import {useIntercom} from "react-use-intercom";

export const useLogout = () => {
  const {shutdown} = useIntercom();
  const navigate = useNavigate();

  const logout = async () => {
    await useTokenStore.getState().logout();
    shutdown();
    navigate("/login", {state: {from: ""}});
  };

  return logout;
};
